var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOrder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.837 6.32647C14.5812 6.32647 16.0003 4.90744 16.0003 3.16325C16.0003 1.41906 14.5813 0 12.837 0C11.0928 0 9.67383 1.41903 9.67383 3.16322C9.67383 4.90741 11.0929 6.32647 12.837 6.32647ZM11.4879 2.58909L12.3225 3.42363L14.0886 1.65753L14.7515 2.32044L12.3225 4.74947L10.825 3.252L11.4879 2.58909Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.69644 11.6964H13.8037L14.2729 7.0045C13.8258 7.17219 13.342 7.26416 12.837 7.26416C10.5759 7.26416 8.73628 5.42456 8.73628 3.16344C8.73628 2.81444 8.78025 2.4755 8.86269 2.15178H3.25994L3.04475 0H0V0.9375H2.19631L3.18712 10.8456C2.58494 11.0566 2.15178 11.6303 2.15178 12.3036C2.15178 13.1553 2.84472 13.8482 3.69644 13.8482H4.42169C4.34166 14.0347 4.29719 14.2399 4.29719 14.4553C4.29719 15.3071 4.99009 16 5.84181 16C6.69353 16 7.38647 15.3071 7.38647 14.4553C7.38647 14.2399 7.342 14.0347 7.26197 13.8482H9.814C9.73397 14.0347 9.6895 14.2399 9.6895 14.4553C9.6895 15.3071 10.3824 16 11.2342 16C12.0859 16 12.7788 15.3071 12.7788 14.4553C12.7788 14.2399 12.7343 14.0347 12.6543 13.8482H13.8036V12.9107H3.69644C3.36166 12.9107 3.08928 12.6383 3.08928 12.3036C3.08928 11.9688 3.36166 11.6964 3.69644 11.6964ZM10.2274 8.60716H11.1649V9.54466H10.2274V8.60716ZM8.06922 8.60716H9.00672V9.54466H8.06922V8.60716ZM5.911 8.60716H6.8485V9.54466H5.911V8.60716Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrder);
export default __webpack_public_path__ + "static/media/order.2c9fa89d442ba7e5719757f910980e95.svg";
export { ForwardRef as ReactComponent };